var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_511_44464"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_511_44464)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 45,
    width: 19,
    height: 3,
    rx: 0,
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 19,
    width: 13,
    height: 31,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.237436,17.8232231Q49.750001,17.3106589,49.750001,16.5857863L49.750001,15.0000001Q49.750001,14.2751267,49.237438,13.76256333Q48.724874,13.25,48,13.25000006L39.0000004,13.25Q38.27512646,13.25,37.76256318,13.76256314Q37.24999988,14.2751264,37.25,15.0000002L37.25,16.5857863Q37.25,17.3106599,37.76256293,17.8232231L39.1767768,19.2374368Q39.6893404,19.75,40.4142137,19.75L46.5857868,19.75Q47.310662300000004,19.75,47.823225,19.2374358L49.237436,17.8232231ZM48.25,15.0000001L48.25,16.5857863Q48.25,16.6893401,48.176777,16.7625632L46.7625618,18.1767769Q46.6893387,18.25,46.5857868,18.25L40.4142137,18.25Q40.3106604,18.25,40.237437,18.1767764L38.82322347,16.7625632Q38.75,16.6893399,38.75,16.5857863L38.75,15.0000001Q38.75,14.75,39.0000004,14.75L48,14.75000012Q48.103555,14.75000012,48.176778,14.82322323Q48.25,14.89644521,48.25,15.0000001Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.5,24.75L40.5,24.75L40.5,23.25L46.5,23.25L46.5,24.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,-16,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25,36.0000005L18.25,53L19.75,53L19.75,36.0000005Q19.75,35.75,20.0000001,35.75L31,35.75Q31.249999000000003,35.75,31.249999000000003,36.0000001L31.249999000000003,53L32.749999,53L32.749999,36.0000001Q32.749999,35.27512661,32.237436,34.76256353Q31.724874,34.25,31,34.25L20.0000001,34.25Q19.27512628,34.24999994,18.76256308,34.76256327Q18.25,35.2751264,18.25,36.0000005Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,-22,22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.237436000000002,39.8232231Q25.750000999999997,39.3106589,25.750000999999997,38.5857863L25.750000999999997,37.0000001Q25.750000999999997,36.2751267,25.237437999999997,35.76256333Q24.724874,35.25,24,35.25000006L15.0000004,35.25Q14.27512646,35.25,13.76256318,35.76256314Q13.24999988,36.2751264,13.25,37.0000002L13.25,38.5857863Q13.25,39.3106599,13.76256293,39.8232231L15.1767768,41.2374368Q15.6893404,41.75,16.4142137,41.75L22.5857868,41.75Q23.3106623,41.75,23.823225,41.2374358L25.237436000000002,39.8232231ZM24.25,37.0000001L24.25,38.5857863Q24.25,38.6893401,24.176777,38.7625632L22.7625618,40.1767769Q22.6893387,40.25,22.5857868,40.25L16.4142137,40.25Q16.3106604,40.25,16.237437,40.1767764L14.82322347,38.7625632Q14.75,38.6893399,14.75,38.5857863L14.75,37.0000001Q14.75,36.75,15.0000004,36.75L24,36.75000012Q24.103555,36.75000012,24.176778,36.823223229999996Q24.25,36.89644521,24.25,37.0000001Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,-14.5,14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,39.25L24,39.25L24,37.75L30,37.75L30,39.25Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5,
    cy: 38.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5,
    cy: 44.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#19191A",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.3abed342b173d6cdffd75709d29dda02.svg";
export { ForwardRef as ReactComponent };